import React from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import style from "../OrderInfoClient.module.scss";
import LogoIcon from "../../../shared/icons/LogoIcon";
import TenderIcon from "../../../shared/icons/TenderIcon";
import UsersIcon from "../../../shared/icons/UsersIcon";
import BoxIcon from "../../../shared/icons/BoxIcon";
import OrdersIcon from "../../../shared/icons/OrdersIcon";
import RailwayIcon from "../../../shared/icons/RailwayIcon";
import HouseIcon from "../../../shared/icons/HouseIcon";
import CheckCircleIcon from "../../../shared/icons/CheckCircleIcon";
import { TRANSPORTATION_TYPES } from "../../../../pages/orders/utils/railwayOrder";

const STATUS_TO_STEP = {
  published: 0,
  moderation: 0,
  awaitingoffer: 1,
  assigned: 2,
  assignedexecutor: 2,
  confirmed: 2,
  headingtoloading: 3,
  processloadingcargo: 3,
  onthetrip: 4,
  processunloadingcargo: 5,
  return: 5,
  unloadingcargomoderation: 5,
  completedbyexecutor: 6,
  completed: 6,
};

const STEPS = [
  { labelKey: "created", Icon: LogoIcon, size: 32 },
  { labelKey: "tender", Icon: TenderIcon, size: 20 },
  { labelKey: "driver", Icon: UsersIcon, size: 22 },
  { labelKey: "loading", Icon: BoxIcon, size: 20 },
  { labelKey: "onTheWay", Icon: OrdersIcon, size: 22 },
  { labelKey: "unloading", Icon: HouseIcon, size: 20 },
  { labelKey: "completed", Icon: CheckCircleIcon, size: 22 },
];

const OrderInfoClientStepper = ({ status, assignmentMethod, transportationType }) => {
  const { t } = useTranslation();
  const currentStep = STATUS_TO_STEP[status] ?? 0;
  const progressPercent = STEPS.length > 1 ? (currentStep / (STEPS.length - 1)) * 100 : 0;

  return (
    <div className={style.stepper}>
      <div className={style.stepper_container}>
        <div className={style.stepper_track}>
          <div className={style.stepper_track_progress} style={{ width: `${progressPercent}%` }} />
        </div>
        {STEPS.map((step, index) => {
          const Icon =
            step.labelKey === "onTheWay" && transportationType === TRANSPORTATION_TYPES.RAILWAY
              ? RailwayIcon
              : step.Icon;
          const isCompleted = index < currentStep;
          const isActive = index === currentStep;
          const isInactive = index > currentStep;
          return (
            <div key={step.labelKey} className={style.stepper_step}>
              <div
                className={cn(style.stepper_step_icon, {
                  [style.stepper_step_icon_active]: isCompleted || isActive,
                  [style.stepper_step_icon_inactive]: isInactive,
                })}
              >
                <Icon
                  width={step.size}
                  height={step.size}
                  fill={
                    Icon === HouseIcon || Icon === RailwayIcon ? "none" : isCompleted || isActive ? "white" : "#6D7885"
                  }
                  color={isCompleted || isActive ? "white" : "#6D7885"}
                  type={Icon === LogoIcon ? 2 : 1}
                />
              </div>
              <span
                className={cn(style.stepper_step_label, {
                  [style.stepper_step_label_active]: isActive,
                  [style.stepper_step_label_completed]: isCompleted,
                  [style.stepper_step_label_inactive]: isInactive,
                })}
              >
                {t(
                  `orderInfoExpeditor.stepper.${
                    step.labelKey === "tender" && assignmentMethod === "Auction" ? "auction" : step.labelKey
                  }`,
                )}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderInfoClientStepper;
